import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Onboarding = ApplicationRecord.extend({
  attrs: {
    access_token: attr({ type: String }),
    first_name: attr({ type: String }),
    last_name: attr({ type: String }),
    marketing_opt_in: attr({ type: Boolean }),
    third_party_marketing_opt_in: attr({ type: Boolean }),
    email: attr({ type: String }),
    password: attr({ type: String }),
    first_delivery_date: attr(),
    first_delivery_recipe_ids: attr({ type: Array }),
    delivery_instructions: attr({ type: String }),
    locality: attr({ type: String }),
    postcode: attr({ type: String }),
    recipient_phone: attr({ type: String }),
    street_1: attr({ type: String }),
    street_2: attr({ type: String }),
    excluded_food_groups: attr({ type: Array }),
    meal_plan: attr({ type: String }),
    portion_count_per_meal: attr({ type: Number }),
    voucher_code: attr({ type: String }),
    referral_email: attr({ type: String }),
    referral_code: attr({ type: String }),
    payment_token: attr({ type: String }),
    dual_flow_newbie: attr({ type: Boolean }),
  },
  static: {
    endpoint: '/onboardings',
    jsonapiType: 'onboardings-onboardings',
  },
});

export default Onboarding;
